import { render, staticRenderFns } from "./BackToEditorButton.vue?vue&type=template&id=f3c301a0&scoped=true&"
import script from "./BackToEditorButton.vue?vue&type=script&lang=js&"
export * from "./BackToEditorButton.vue?vue&type=script&lang=js&"
import style0 from "./BackToEditorButton.vue?vue&type=style&index=0&id=f3c301a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c301a0",
  null
  
)

export default component.exports